<template>
  <div style="height: 100%; background: #f5f5f5;">
    <div v-if="!this.$route.query.download">
      <div v-if="!this.$route.query.download && widget.properties.view_gate.visible && typeof(search.properties.view_gate_submitted) == 'undefined'" class="fixed top-0 left-0 h-full w-full flex flex-column items-center justify-center" style="background-color: rgba(0,0,0,.2); z-index: 8;">
        <div class="w-full sm:w-1/2 lg:w-2/6 bg-white rounded-lg mx-6" style="max-width: 92%;">

          <div class="rg-modal-header">
            Get Your Report
          </div>

          <div class="p-6">
              <div>
                  <div style="text-align: center; font-size: 12px;" class="mb-4" v-if="widget.properties.view_gate.show_headline == true">
                    <h3 class="pt-2">{{ widget.properties.view_gate.headline_text }}</h3>
                  </div>
  
                  <div class="flex flex-wrap">
                      <div v-if="widget.properties.view_gate.first_name_visible" :class="((!widget.properties.view_gate.first_last_one_line || !widget.properties.view_gate.last_name_visible) ? 'w-full mb-3 md:mb-0' : 'w-full md:w-1/2 pr-3 mb-3 md:mb-0')">
                            <p class="mb-1 text-xs mb-2"><strong>
                                {{ widget.properties.view_gate.first_placeholder_text }}
                            </strong></p>
                          <input name="first_name" ref="view_gate_first_name" class="rg-text-field block appearance-none focus:outline-none focus:border-gray-500 w-full bg-white hover:border-grey px-2 py-2 rounded" type="text" :placeholder="widget.properties.view_gate.first_placeholder_text">
                      </div>
                      <div v-if="widget.properties.view_gate.last_name_visible" :class="((!widget.properties.view_gate.first_last_one_line || !widget.properties.view_gate.first_name_visible) ? 'w-full mb-3 md:mb-0' : 'w-full md:w-1/2 md:mb-0')">
                            <p class="mb-1 text-xs mb-2"><strong>
                                {{ widget.properties.view_gate.last_placeholder_text }}
                            </strong></p>
                          <input name="last_name" ref="view_gate_last_name" class="rg-text-field block appearance-none focus:outline-none focus:border-gray-500 w-full bg-white hover:border-grey px-2 py-2 rounded" type="text" :placeholder="widget.properties.view_gate.last_placeholder_text">
                      </div>
                  </div>
  
                  <div class="mb-2">
                        <p class="mb-1 text-xs mb-2"><strong>
                            {{ widget.properties.view_gate.email_placeholder_text }}
                        </strong></p>
                      <input name="email" ref="view_gate_email" class="rg-text-field block appearance-none focus:outline-none focus:border-gray-500 w-full bg-white hover:border-grey px-2 py-2 rounded" type="text" :placeholder="widget.properties.view_gate.email_placeholder_text">
                  </div>
  
                  <div style="text-align: center;" class="">
                    <div v-if="widget.properties.view_gate.show_spam_disclaimer" class="text-xs text-gray-700 mt-1">
                        <i class="fa fa-lock"></i> &nbsp; {{ widget.properties.view_gate.spam_disclaimer_text }}
                    </div>

                    <div class="rg-dialog-button-save rounded text-white text-xs text-bold focus:outline-none py-2 px-4 mt-3" style="display: inline-block" @click="submitViewGate()" v-bind:style="{ backgroundColor: widget.properties.view_gate.submit_button_color }">{{ widget.properties.view_gate.submit_button_text }}</div>
                  </div>
              </div>

              <div style="clear: both;"></div>

              <!-- <p class="text-xs text-gray-700 mb-4">Your contact's phone number.</p> -->

          </div>
        </div>
      </div>

      <div v-if="showHelpRequestModal" class="fixed top-0 left-0 h-full w-full flex flex-column items-center justify-center" style="background-color: rgba(0,0,0,.2); z-index: 8;">
        <div class="w-full sm:w-1/2 lg:w-1/3 bg-white rounded-lg mx-6" style="max-width: 96%;">

          <div class="rg-modal-header">
            Get Help

            <a href="javascript: void(0);" class="rg-modal-close-btn" @click="showHelpRequestModal = false"><i class="mdi mdi-close"></i></a>
          </div>

        <div class="p-6 pt-3">

            <div>
                <div style="text-align: center; font-size: 12px;" class="mb-4">
                    <h2 class="pt-2" style="font-weight: bold;">{{ widget.properties.action_options.header_text_top_fixing_listing }}</h2>
                    <h3 class="pt-2">{{ widget.properties.action_options.header_text_bottom_fixing_listing }}</h3>
                </div>

                <div v-if="widget.properties.action_options.first_name_visible" class="mb-2">
                    <p class="mb-1 text-xs mb-2" v-show="!$vuetify.breakpoint.xs"><strong>
                        {{ widget.properties.action_options.first_placeholder_text }}
                    </strong></p>
                    <input name="first_name" ref="first_name" class="rg-text-field block appearance-none focus:outline-none focus:border-gray-500 w-full bg-white hover:border-grey px-2 py-2 rounded" type="text" :placeholder="widget.properties.action_options.first_placeholder_text">
                </div>

                <div v-if="widget.properties.action_options.last_name_visible" class="mb-2">
                    <p class="mb-1 text-xs mb-2" v-show="!$vuetify.breakpoint.xs"><strong>
                        {{ widget.properties.action_options.last_placeholder_text }}
                    </strong></p>
                    <input name="last_name" ref="last_name" class="rg-text-field block appearance-none focus:outline-none focus:border-gray-500 w-full bg-white hover:border-grey px-2 py-2 rounded" type="text" :placeholder="widget.properties.action_options.last_placeholder_text">
                </div>

                <div class="mb-2">
                    <p class="mb-1 text-xs mb-2" v-show="!$vuetify.breakpoint.xs"><strong>
                        {{ widget.properties.action_options.email_placeholder_text }}
                    </strong></p>
                    <input name="email" ref="email" class="rg-text-field block appearance-none focus:outline-none focus:border-gray-500 w-full bg-white hover:border-grey px-2 py-2 rounded" type="text" :placeholder="widget.properties.action_options.email_placeholder_text">
                </div>

                <div class="mb-2">
                    <p class="mb-1 text-xs mb-2" v-show="!$vuetify.breakpoint.xs"><strong>
                        Company Name
                    </strong></p>
                    <input name="company_name" ref="company_name" class="rg-text-field block appearance-none focus:outline-none focus:border-gray-500 w-full bg-white hover:border-grey px-2 py-2 rounded" type="text" :placeholder="'Company Name...'">
                </div>

                <div class="mb-2">
                    <p class="mb-1 text-xs mb-2" v-show="!$vuetify.breakpoint.xs"><strong>
                        Company Address
                    </strong></p>
                    <input name="company_address" ref="company_address" class="rg-text-field block appearance-none focus:outline-none focus:border-gray-500 w-full bg-white hover:border-grey px-2 py-2 rounded" type="text" :placeholder="'Company Address...'">
                </div>

                <div class="flex flex-wrap">
                    <div :class="(($vuetify.breakpoint.xs) ? 'w-full md:w-1/3 mb-2' : 'w-full md:w-1/3 pr-3 mb-6')">
                        <p class="mb-1 text-xs mb-2" v-show="!$vuetify.breakpoint.xs"><strong>
                          City
                        </strong></p>
                        <input class="rg-text-field block appearance-none focus:outline-none focus:border-gray-500 w-full bg-white hover:border-grey px-2 py-2 rounded" id="grid-first-name" type="text" ref="city" placeholder="City...">
                    </div>
                    <div :class="(($vuetify.breakpoint.xs) ? 'w-full md:w-1/3 mb-2' : 'w-full md:w-1/3 px-3 mb-6')">
                        <p class="mb-1 text-xs mb-2" v-show="!$vuetify.breakpoint.xs"><strong>
                          State
                        </strong></p>
                        <input class="rg-text-field block appearance-none focus:outline-none focus:border-gray-500 w-full bg-white hover:border-grey px-2 py-2 rounded" id="grid-last-name" type="text" ref="state" placeholder="State...">
                    </div>
                    <div :class="(($vuetify.breakpoint.xs) ? 'w-full md:w-1/3 mb-2' : 'w-full md:w-1/3 pl-3 mb-6')">
                        <p class="mb-1 text-xs mb-2" v-show="!$vuetify.breakpoint.xs"><strong>
                          Zip
                        </strong></p>
                        <input class="rg-text-field block appearance-none focus:outline-none focus:border-gray-500 w-full bg-white hover:border-grey px-2 py-2 rounded" id="grid-last-name" type="text" ref="zip" placeholder="Zip...">
                    </div>
                </div>

                <div style="text-align: center;" class="">
                    <div v-if="widget.properties.action_options.spam_disclaimer_visible" class="text-xs text-gray-700 mt-1">
                        <i class="fa fa-lock"></i> &nbsp;{{ widget.properties.action_options.spam_disclaimer_text }}
                    </div>

                    <div class="rg-dialog-button-save rounded text-white text-xs text-bold focus:outline-none py-2 px-4 mt-3" style="display: inline-block" @click="submitGetHelp()" v-bind:style="{ backgroundColor: widget.properties.action_options.button_color }">{{ widget.properties.action_options.submit_button_text }}</div>
                </div>
            </div>

            <div style="clear: both;"></div>

            <!-- <p class="text-xs text-gray-700 mb-4">Your contact's phone number.</p> -->

        </div>

        </div>
      </div>
    </div>

    <div v-if="search" style="height: 100%;">
      <div class="lr-report-header">
        <div class="lr-report-title">
          
<svg width="71" height="30" viewBox="0 0 71 30" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M25 12.5C25 5.59644 19.4036 0 12.5 0C5.59644 0 0 5.59644 0 12.5C0 19.4036 5.59644 25 12.5 25H25V12.5Z" fill="white"/>
<path d="M32.54 25C32.4067 25 32.2933 24.9533 32.2 24.86C32.1067 24.7667 32.06 24.6533 32.06 24.52V11.48C32.06 11.3467 32.1067 11.2333 32.2 11.14C32.2933 11.0467 32.4067 11 32.54 11H34.4C34.5333 11 34.6467 11.0467 34.74 11.14C34.8333 11.2333 34.88 11.3467 34.88 11.48V22.62H41.22C41.3667 22.62 41.4867 22.6667 41.58 22.76C41.6733 22.8533 41.72 22.9733 41.72 23.12V24.52C41.72 24.6533 41.6733 24.7667 41.58 24.86C41.4867 24.9533 41.3667 25 41.22 25H32.54ZM49.3549 25.2C48.1149 25.2 47.0749 25.02 46.2349 24.66C45.4082 24.2867 44.7749 23.8067 44.3349 23.22C43.9082 22.62 43.6816 21.9933 43.6549 21.34C43.6549 21.22 43.6949 21.12 43.7749 21.04C43.8549 20.96 43.9549 20.92 44.0749 20.92H45.8549C46.0282 20.92 46.1549 20.96 46.2349 21.04C46.3282 21.1067 46.4082 21.1933 46.4749 21.3C46.5549 21.5533 46.7082 21.8067 46.9349 22.06C47.1616 22.3 47.4682 22.5 47.8549 22.66C48.2549 22.82 48.7549 22.9 49.3549 22.9C50.3149 22.9 51.0282 22.74 51.4949 22.42C51.9749 22.1 52.2149 21.6667 52.2149 21.12C52.2149 20.7333 52.0882 20.4267 51.8349 20.2C51.5816 19.96 51.1882 19.7467 50.6549 19.56C50.1349 19.36 49.4416 19.1533 48.5749 18.94C47.5749 18.7 46.7349 18.4133 46.0549 18.08C45.3882 17.7333 44.8816 17.3 44.5349 16.78C44.2016 16.26 44.0349 15.6 44.0349 14.8C44.0349 14.0267 44.2416 13.34 44.6549 12.74C45.0816 12.14 45.6816 11.6667 46.4549 11.32C47.2416 10.9733 48.1749 10.8 49.2549 10.8C50.1216 10.8 50.8882 10.92 51.5549 11.16C52.2216 11.3867 52.7749 11.6933 53.2149 12.08C53.6549 12.4533 53.9882 12.86 54.2149 13.3C54.4549 13.7267 54.5816 14.1467 54.5949 14.56C54.5949 14.6667 54.5549 14.7667 54.4749 14.86C54.4082 14.94 54.3082 14.98 54.1749 14.98H52.3149C52.2082 14.98 52.1016 14.9533 51.9949 14.9C51.8882 14.8467 51.8016 14.7467 51.7349 14.6C51.6549 14.1867 51.3949 13.8333 50.9549 13.54C50.5149 13.2467 49.9482 13.1 49.2549 13.1C48.5349 13.1 47.9549 13.2333 47.5149 13.5C47.0749 13.7667 46.8549 14.18 46.8549 14.74C46.8549 15.1133 46.9616 15.4267 47.1749 15.68C47.4016 15.92 47.7549 16.1333 48.2349 16.32C48.7282 16.5067 49.3749 16.7067 50.1749 16.92C51.3082 17.1733 52.2349 17.4667 52.9549 17.8C53.6749 18.1333 54.2016 18.56 54.5349 19.08C54.8682 19.5867 55.0349 20.2333 55.0349 21.02C55.0349 21.9 54.7949 22.6533 54.3149 23.28C53.8482 23.8933 53.1882 24.3667 52.3349 24.7C51.4816 25.0333 50.4882 25.2 49.3549 25.2ZM57.0854 25C56.9787 25 56.8787 24.96 56.7854 24.88C56.7054 24.8 56.6654 24.7 56.6654 24.58C56.6654 24.5267 56.6787 24.4667 56.7054 24.4L61.5254 11.5C61.5654 11.3667 61.6387 11.2533 61.7454 11.16C61.8654 11.0533 62.0254 11 62.2254 11H64.4054C64.6054 11 64.7587 11.0533 64.8654 11.16C64.9721 11.2533 65.0521 11.3667 65.1054 11.5L69.9254 24.4C69.9388 24.4667 69.9454 24.5267 69.9454 24.58C69.9454 24.7 69.9054 24.8 69.8254 24.88C69.7454 24.96 69.6521 25 69.5454 25H67.8054C67.6188 25 67.4787 24.96 67.3854 24.88C67.3054 24.7867 67.2521 24.7 67.2254 24.62L66.2854 22.18H60.3454L59.4054 24.62C59.3787 24.7 59.3187 24.7867 59.2254 24.88C59.1454 24.96 59.0121 25 58.8254 25H57.0854ZM61.0454 19.88H65.5854L63.3054 13.7L61.0454 19.88Z" fill="white"/>
</svg>

        </div>

        <div class="lr-report-buttons">
          <div v-if="!this.$route.query.download">
            <div class="border-1 border-blue bg-blue text-white text-xs text-bold px-4 py-2 rounded cursor-pointer mr-2" @click="getHelp()" style="margin-top: -5px; background-color: #19233a; border-color: #bfbfbf; display: inline-block;">GET HELP</div>
            
            <div class="border-1 border-blue text-xs text-bold px-4 py-2 rounded cursor-pointer" @click="downloadReport()" style="margin-top: -5px; background: #2477F6; color: #FFFFFF; display: inline-block;"><span v-if="!downloadingReport">Download Report <i class="fa fa-chevron-down ml-2" style="font-size: 10px;"> </i></span> <span v-if="downloadingReport">Downloading...</span></div>
          </div>
        </div>

        <div class="clearfix"></div>

        <div class="lr-report-type-title">
          <span v-if="search.search_type == 'business_audit'">
            Review Audit
          </span>

          <span v-if="search.search_type == 'seo_audit'">
            SEO Audit
          </span>

          <span v-if="search.search_type == 'grid_tracker_scan'">
            Grid Tracker
          </span>

          <span v-if="search.search_type == 'lsa_audit'">

            <div v-if="search.settings.audit_show_agency_name || search.settings.audit_show_agency_website">
              <div v-if="search.settings.audit_show_agency_name">{{ search.settings.agency_name }}</div>
              <div v-if="search.settings.audit_show_agency_website"><a :href="search.settings.agency_website" target="agency-website">{{ search.settings.agency_website }}</a></div>
            </div>
            <div v-else>
              LSA Audit
            </div>

            <div style="font-size: 14px; font-weight: normal; padding-top: 10px;">
              Here is your LSA report. See details, suggestions and improve your rankings with one click.
            </div>
          </span>
        </div>
      </div>

      <div :class="'lr-report-container ' + ((((widget.properties.view_gate.visible && typeof(search.properties.view_gate_submitted) == 'undefined') || (1 && loading && !this.$route.query.download)) ? 'blur' : '') + '')"  style="height: 100%;">


        <div v-if="search.search_type == 'lsa_audit'">
          <LSAAudit :search="search" />
        </div>
      </div>
    </div>

    <div v-if="loading && !this.$route.query.download && !widget.properties.view_gate.visible" class="fixed top-0 left-0 h-full w-full flex flex-column items-center justify-center" style="background-color: rgba(0,0,0,.2); z-index: 8;">
        <div class="w-full bg-white mx-6" style="width: 380px; max-width: 96%; border-radius: 5px;">

          <div class="p-6">
              <div v-if="search.search_type == 'lsa_audit'">
                <h4 class="main-title"><strong>Scanning To Find Your Business LSA Reputation</strong></h4>

                <h5 class="sub-title">This can take a couple minutes...</h5>

                <div style="clear: both;"></div>

                <div style="float: left; position: relative;">
                  <v-progress-circular
                    indeterminate
                    :size="30"
                    width="3"
                    color="primary"
                    
                  ></v-progress-circular>
                  <i class="fa fa-briefcase loading-icon"></i>
                </div>
                <div style="float: left; font-size: 12px; color: #19233A; padding-left: 8px; padding-top: 6px;">
                  Company Information
                </div>
                <div style="clear: both;"></div>

                <div style="float: left; position: relative;">
                  <v-progress-circular
                    indeterminate
                    :size="30"
                    width="3"
                    color="primary"
                    
                  ></v-progress-circular>
                  <i class="fa fa-users loading-icon"></i>
                </div>
                <div style="float: left; font-size: 12px; color: #19233A; padding-left: 8px; padding-top: 6px;">
                  Competitors
                </div>
                <div style="clear: both;"></div>

                <div style="float: left; position: relative;">
                  <v-progress-circular
                    indeterminate
                    :size="30"
                    width="3"
                    color="primary"
                    
                  ></v-progress-circular>
                  <i class="fa fa-star loading-icon"></i>
                </div>
                <div style="float: left; font-size: 12px; color: #19233A; padding-left: 8px; padding-top: 6px;">
                  Ratings & Reviews
                </div>
                <div style="clear: both;"></div>

                <div style="float: left; position: relative;">
                  <v-progress-circular
                    indeterminate
                    :size="30"
                    width="3"
                    color="primary"
                    
                  ></v-progress-circular>
                  <i class="fa fa-file-pdf loading-icon"></i>
                </div>
                <div style="float: left; font-size: 12px; color: #19233A; padding-left: 8px; padding-top: 6px;">
                  Service Areas
                </div>
                <div style="clear: both;"></div>

                <div style="float: left; position: relative;">
                  <v-progress-circular
                    indeterminate
                    :size="30"
                    width="3"
                    color="primary"
                    
                  ></v-progress-circular>
                  <i class="fa fa-list loading-icon"></i>
                </div>
                <div style="float: left; font-size: 12px; color: #19233A; padding-left: 8px; padding-top: 6px;">
                  Business Hours
                </div>
                <div style="clear: both;"></div>

                <div style="float: left; position: relative;">
                  <v-progress-circular
                    indeterminate
                    :size="30"
                    width="3"
                    color="primary"
                    
                  ></v-progress-circular>
                  <i class="fa fa-search loading-icon"></i>
                </div>
                <div style="float: left; font-size: 12px; color: #19233A; padding-left: 8px; padding-top: 6px;">
                  LSA Search Results
                </div>
                <div style="clear: both;"></div>
              </div>

              <div style="clear: both;"></div>

              <!-- <p class="text-xs text-gray-700 mb-4">Your contact's phone number.</p> -->

          </div>
        </div>
      </div>
  </div>
</template>


<script>
import axios from 'axios'
import $ from 'jquery'
import ApexCharts from 'apexcharts'
import LSAAudit from '@/views/local-recon/ReportsTemplates/LSAAudit.vue'

export default {
metaInfo () {
  return {
    title: "Report | " + this.$appName
  }
},
components: {
  ApexCharts,
  LSAAudit
},
data () {
  return {
    loading: true,
    currentLoadingText: 1,

    widget: false,
    search: false,

    showHelpRequestModal: false,

    downloadingReport: false,

    
  }
},
methods: {
  ucwords (str) {
    return (str + '').replace(/^([a-z])|\s+([a-z])/g, function ($1) {
        return $1.toUpperCase();
    });
  },

  async loadReport() {
    let self = this;

    let url = process.env.VUE_APP_API_ENDPOINT + '/local-recon/get-report?s=' + this.$route.query.s + '&p=' + this.$route.query.p;
    
    let response = await axios.get(url, {

    })

    let previous_success = true;
    let previous_reviews_success = true;
    let previous_posts_success = true;

    if (this.search && this.search.search_type == "lsa_audit") {
      previous_success = this.search.properties.success
    }

    self.loading = false;

    this.widget = response.data.widget;
    this.search = response.data.search;

    let bizHours;

    for (var i in this.search.properties.summary.items) {
      if (this.search.properties.summary.items[i].title == 'Business Hours') {
        bizHours = JSON.parse(JSON.stringify(this.search.properties.summary.items[i]));
        this.search.properties.summary.items[i].hidden = true;
      }
    }

    console.log('this.search.properties.summary.items', this.search.properties.summary.items);

    console.log('bizHours', bizHours);

    let newItems = [
        ...this.search.properties.summary.items.slice(0, 2),
        bizHours,
        ...this.search.properties.summary.items.slice(2)
    ];

    this.search.properties.summary.items = newItems;

    // console.log('this.widget', this.widget)
  // Apply custom CSS
  if (this.widget.properties.custom_css) {
      if (document.getElementById("lr-widget-custom-css-sheet") === null) {
          var styleSheet = document.createElement("style")
          styleSheet.type = "text/css"
          styleSheet.innerText = this.widget.properties.custom_css.replace(/\n/g, " ")
          styleSheet.id = 'lr-widget-custom-css-sheet';
          document.body.appendChild(styleSheet);
      }
      else {
          document.getElementById("lr-widget-custom-css-sheet").innerText = this.widget.properties.custom_css.replace(/\n/g, " ");
      }
  }
  else {
      if (document.getElementById("lr-widget-custom-css-sheet") === null) {
          var styleSheet = document.createElement("style")
          styleSheet.type = "text/css"
          styleSheet.innerText = ""
          styleSheet.id = 'lr-widget-custom-css-sheet';
          document.body.appendChild(styleSheet);
      }
      else {
          document.getElementById("lr-widget-custom-css-sheet").innerText = '';
      }
  }
  // END Apply custom CSS
  },
  async submitViewGate() {
    console.log(1);
    if (this.widget.properties.view_gate.first_name_visible && this.widget.properties.view_gate.first_name_mandatory) {
      if (this.$refs.view_gate_first_name.value.trim() == "") {
        this.$swal({
          icon: 'error',
          // title: "First Name",
          html: "Please enter your first name.",
          confirmButtonText: 'OK'
        }).then(function() {

        });
        return;
      }
    }
    console.log(2);
    if (this.widget.properties.view_gate.last_name_visible && this.widget.properties.view_gate.last_name_mandatory) {
      if (this.$refs.view_gate_last_name.value.trim() == "") {
        this.$swal({
          icon: 'error',
          // title: "First Name",
          html: "Please enter your last name.",
          confirmButtonText: 'OK'
        }).then(function() {

        });
        return;
      }
    }
    console.log(3);
    if (!this.validateEmail(this.$refs.view_gate_email.value.trim())) {
      this.$swal({
        icon: 'error',
        // title: "Error",
        html: "Please enter a valid email address.",
        confirmButtonText: 'OK'
      }).then(function() {

      });
      return;
    }
    console.log(4);
      
    let url = process.env.VUE_APP_API_ENDPOINT + '/local-recon/submit-view-gate?s=' + this.$route.query.s + '&p=' + this.$route.query.p;
    
    let response = await axios.post(url, {
      first_name: this.$refs.view_gate_first_name.value.trim(),
      last_name: this.$refs.view_gate_last_name.value.trim(),
      email: this.$refs.view_gate_email.value.trim()
    } , {
        headers: {
            'Authorization': 'Bearer ' + this.$store.state.auth.jwt
        },
    })

    // location.reload(true);

    this.$swal({
        title: "Submitted",
        text: "Thank you! We will email your report to you as soon as it is completed.",
        showCancelButton: false,
    }).then(function() {
      window.history.go(-1);
    });
  },
  async submitGetHelp() {
    if (this.widget.properties.action_options.first_name_visible && this.widget.properties.action_options.first_name_mandatory) {
      if (this.$refs.first_name.value.trim() == "") {
        this.$swal({
          icon: 'error',
          // title: "First Name",
          html: "Please enter your first name.",
          confirmButtonText: 'OK'
        }).then(function() {

        });
        return;
      }
    }

    if (this.widget.properties.action_options.last_name_visible && this.widget.properties.action_options.last_name_mandatory) {
      if (this.$refs.last_name.value.trim() == "") {
        this.$swal({
          icon: 'error',
          // title: "First Name",
          html: "Please enter your last name.",
          confirmButtonText: 'OK'
        }).then(function() {

        });
        return;
      }
    }

    if (!this.validateEmail(this.$refs.email.value.trim())) {
      this.$swal({
        icon: 'error',
        // title: "Error",
        html: "Please enter a valid email address.",
        confirmButtonText: 'OK'
      }).then(function() {

      });
      return;
    }
      
    let url = process.env.VUE_APP_API_ENDPOINT + '/local-recon/submit-get-help?s=' + this.$route.query.s + '&p=' + this.$route.query.p;
    
    let response = await axios.post(url, {
      first_name: this.$refs.first_name.value.trim(),
      last_name: this.$refs.last_name.value.trim(),
      email: this.$refs.email.value.trim(),
      company_name: this.$refs.company_name.value.trim(),
      company_address: this.$refs.company_address.value.trim(),
      city: this.$refs.city.value.trim(),
      state: this.$refs.state.value.trim(),
      zip: this.$refs.zip.value.trim()
    })

    this.$swal({
      title: "Thank you!",
      text: "Thank you for contacting us! We will get back to you soon.",
      showCancelButton: false,
      confirmButtonText: 'Close'
    }).then(function() {
      
    });

    this.showHelpRequestModal = false
  },
  getHelp() {
    if (this.widget.properties.action_options.landing_page_action_type_id == 2) {
      window.location = this.widget.properties.action_options.redirect_link_url;
    }
    else {
      this.showHelpRequestModal = true
    }
  },
  validateEmail(email) 
  {
      var re = /\S+@\S+\.\S+/;
      return re.test(email);
  },

  async downloadReport() {
      let self = this;
      this.downloadingReport = true;

      let href;

      if (this.search.search_type == 'seo_audit') {
        href = this.search.properties.data.output.pdf;
      }
      else {
        // let url = process.env.VUE_APP_API_ENDPOINT + '/local-recon/download-report';
        let url = 'https://localreconapi.ravu.me/local-recon/download-report';
      
        // let response = await axios.post(url, {
        //   report_url: window.location.href + "&download=1"
        // });

        var data = new FormData();
        data.append( "report_url", window.location.href + "&download=1" );

        const requestOptions = {
            method: 'POST',
            headers: { },
            body: data
        };
        fetch(url, requestOptions)
            .then(function(response) {
              href = response.data.url;

              var anchor = document.createElement('a');
              anchor.href = href;
              anchor.target = '_blank';
              anchor.download = 'rep-report.pdf';
              document.body.appendChild(anchor);
              anchor.click();

              self.downloadingReport = false;
            })
      }

      
  }
},
created() {
  let that = this
  setInterval(function() {
    $("#carousel").fadeOut(500);

    setTimeout(function() {
      that.currentLoadingText++;

      if (that.currentLoadingText == 6)
        that.currentLoadingText = 1;

      $("#carousel").fadeIn(500);
    }, 500);
  }, 6000);

  that.loadReport();
}
}
</script>

<style>
  html, body {
      height: 100%;
  }

  @import url(https://fonts.googleapis.com/css?family=Open+Sans:400,400italic,600,700,800);
  body{
    /*background: red;*/
    font-family: 'Open Sans', sans-serif;
    font-weight: 400;
  }

  .v-slider__thumb {
    display: none !important;
  }

  .blur {
      -webkit-filter: blur(3px);
      -moz-filter: blur(3px);
      -ms-filter: blur(3px);
      -o-filter: blur(3px);
      filter: url(data:image/svg+xml;utf8,<svg height='0' xmlns='http://www.w3.org/2000/svg'>…eGaussianBlur in='SourceGraphic' stdDeviation='5'/></filter></svg>#svgBlur);
      filter: progid:DXImageTransform.Microsoft.Blur(PixelRadius='3');
      filter: blur(3px);
  }

  .v-progress-circular--indeterminate:not(.v-progress-circular--visible) .v-progress-circular__overlay, .v-progress-circular--indeterminate:not(.v-progress-circular--visible)>svg {
    -webkit-animation-play-state: running !important;
    animation-play-state: running !important;
  }

  .v-progress-circular {
    margin: auto;
    display: block;
  }
  
  #report-loading-wrapper img{
    width: 164px;
    margin-top: 40px;
    margin-bottom: 35px;
    margin-left: -10px;
  }

  #report-loading-wrapper .text{
    color:#fff;
    position: absolute;
    top:230px;
    left:0px;
    right:0px;
    margin: auto;

  }
  #report-loading-wrapper h4{
    font-size: 15px;
    font-weight: bold;
    margin-top: 0px;
    margin-bottom: 20px;


  }

  .main-title{
    font-size: 14px !important;
    color:#000000;
    margin-bottom: 15px;
  }
  .title{
    font-size: 20px !important;
    color:#22b661;
    margin-bottom: 15px;
    padding-top: 15px;
    display: none;

  }
  #report-loading-wrapper #carousel {
    background: #e3e9ec;
    display: none;
    border-radius: 2px !important;
    margin-top: 20px;
    padding-bottom: 15px;
    opacity: 0.7;
  }
  #report-loading-wrapper .detail{
    font-size: 26px !important;
    color:#333;
    font-weight: normal;
    font-style: italic;
    margin-top: 10px;
  }
  #report-loading-wrapper .detail i{
    font-size: 18px;
  }
  #report-loading-wrapper .detail p {
      font-style:normal;
      margin-top: 7px;
  }
  .sub-title{
    font-size: 12px !important;
    color: #757B89;
    font-weight: normal;
    margin-bottom: 15px;
  }
  #report-loading-wrapper .name{
    font-size: 18px !important;
    color:#8E8A8A;
    margin-bottom: 15px;
  }

  #report-loading-wrapper .load-container {
    width: 280px;
    height: 280px;
    overflow: hidden;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
    position: absolute;
    top:113px;
    right:0px;
    left:0px;
    margin: auto;
  }

  #report-loading-wrapper .loader {
    margin: 60px auto;
    font-size: 10px;
    position: relative;
    text-indent: -9999em;
    border-top: 0.8em solid rgba(255,255,255, 0.3);
    border-right: 0.8em solid rgba(255,255,255, 0.3);
    border-bottom: 0.8em solid rgba(255,255,255, 0.3);
    border-left: 0.8em solid rgba(255,255,255, 0.3);
    /*-webkit-transform: translateZ(0);
    -ms-transform: translateZ(0);
    transform: translateZ(0);
    -webkit-animation: load8 1.1s infinite linear;
    animation: load8 1.1s infinite linear;*/
  }
  #report-loading-wrapper .loader,
  #report-loading-wrapper .loader:after {
    border-radius: 50%;
    width: 13em;
    height: 13em;
  }
  @-webkit-keyframes load8 {
    0% {
      -webkit-transform: rotate(0deg);
      transform: rotate(0deg);
    }
    100% {
      -webkit-transform: rotate(360deg);
      transform: rotate(360deg);
    }
  }
  @keyframes load8 {
    0% {
      -webkit-transform: rotate(0deg);
      transform: rotate(0deg);
    }
    100% {
      -webkit-transform: rotate(360deg);
      transform: rotate(360deg);
    }
  }

  #report-loading-wrapper body{
    overflow: hidden;
    margin: 0;
    position: relative;
  }

  @keyframes circle {
    from {
      transform: scale(0);
        opacity: 0.3;
    }
    to {
      transform: scale(1.2);
      opacity: 0.0;
    }
  }
  #report-loading-wrapper .circle {
    margin: 0 auto;
    width: 300px;
    height: 300px;
    border: 7px solid #31af91;
    border-radius: 50%;
    position: absolute;
    top: 135px;
    left: 0px;
    right: 0px;
    margin: auto;
    z-index: -1;
    opacity: 0.3
  }
  #report-loading-wrapper .one {
    animation: circle 4s infinite linear;
  }
  #report-loading-wrapper .two {
    animation: circle 3s infinite linear;
  }
  #report-loading-wrapper .three {
    animation: circle 2s infinite linear;
  }
  #report-loading-wrapper .carousel-indicators .active{
    background-color: #31af91;
  }

  #report-loading-wrapper .carousel-indicators li {
    border: 1px solid #31af91;
  }
  #report-loading-wrapper .carousel-indicators {
      bottom: -51px;
  }
  #report-loading-wrapper .carousel-inner{
    /*background-color: #22b661 !important;*/
    border-radius: 2px;
  }

  .mx-auto.v-card, .v-list-item {
    height: 100%;
  }

  .loading-icon {
    font-size: 12px; color: #44468F; position: absolute; margin-top: -28px; margin-left: 4px; left: 5px; right: 0px;
  }

  .v-progress-circular {
    margin: auto !important;
    margin-bottom: 8px !important;
  }

  @media (max-width : 1200px) {
    #report-loading-wrapper .detail {
      font-size: 21px !important;
    }
  }
  @media (max-width : 992px) {
    #report-loading-wrapper img {
      margin-top: 25px;
      margin-bottom: 15px;
    }
    #report-loading-wrapper .load-container {
      top:90px;
    }
    #report-loading-wrapper .text{
      top:205px;
    }
    #report-loading-wrapper .circle{
      top:70px;
    }
  }
  @media (max-width : 480px) {
    #report-loading-wrapper .main-title {
      font-size: 15px !important;
    }
    #report-loading-wrapper .detail {
      font-size: 16px !important;
    }

    .loading-icon {
      margin-top: -33px;
      margin-left: 0px;
      font-size: 12px;
    }
  }


  .lr-report-header {
    background: #112148;
    opacity: 0.9;
    height: auto;
    padding: 35px;
    padding-bottom: 200px;
  }
  
  .lr-report-title {
    float: left;
    color: #FFFFFF;
    font-size: 20px;
  }

  .lr-report-buttons {
    float: right;
  }

  .lr-report-type-title {
    color: #FFFFFF;
    font-size: 30px;
    font-weight: bold;
    text-align: center;
    padding-top: 20px
  }

  .lr-report-container {
    padding: 80px;
    color: #19233A !important;
    font-size: 12px;
    max-width: 1400px;
    margin: auto;
    margin-top: -240px;
  }

  .lr-report-subtitle {
    font-size: 18px;
    color: 16px;
    font-weight: bold;
  }

  .lr-faq-keywords {
    height: 60px; line-height: 50px; padding-top: 10px;
  }

  .lr-doughnut-wrapper {
    position: relative;
  }

  .lr-doughnut-wrapper .lr-doughnut-title {
    position: absolute;
    font-size: 36px;
    font-weight: bold;
    padding-left: 88px;
    padding-top: 47px;
  }

  .lr-doughnut-wrapper .lr-doughnut-title.not-grade {
    padding-left: 82px;
  }

  .lr-doughnut-wrapper .lr-doughnut-subtitle {
    color: #757B89;
    font-size: 12px;
    font-weight: bold;
    text-align: center;
  }

  .lr-overall-box-left {
    float: left;
    width: 45%;
  }

  .lr-overall-box-right {
    float: left;
    width: 45%;
  }

  .lr-seo-box-left {
    float: left;
    width: 35%;
    padding-top: 10px;
  }

  .lr-seo-box-right {
    float: left;
    width: 55%;
  }

  .lr-recommendations-nr {
    width: 223px; height: 45px; color: #FFFFFF; background: #19233A; border-radius: 5px; padding: 13px 20px; font-size: 12px; margin-top: 10px; font-weight: bold;
    text-align: center;
  }

  .lr-radar-wrapper {
    padding-top: 65px;
  }

  .lr-backlinks-stats {
    clear: both;
    padding-top: 30px;
  }

  .lr-backlinks-stats .lr-backlinks-stat {
    float: left;
    text-align: center;
    padding-right: 50px;
  }

  .lr-backlinks-stats .lr-backlinks-stat.even {
    width: 16.6%;
  }

  .lr-backlinks-stats .lr-backlinks-stat .lr-backlinks-stat-icon {
    color: #2477F6;
    font-size: 35px;
  }

  .lr-backlinks-stats .lr-backlinks-stat .lr-backlinks-stat-value {
    color: #273042;
    font-weight: bold;
    font-size: 16px;
  }

  .lr-backlinks-stats .lr-backlinks-stat .lr-backlinks-stat-description {
    color: #273042;
    font-size: 16px;
  }

  .lr-seo-audit-photo {
    position: relative; text-align: right;
  }

  @media (max-width : 480px) {
    .lr-report-container {
      padding: 10px;
      margin-top: -180px;
    }

    .lr-report-type-title {
      font-size: 17px;
    }

    .loading-icon {
      left: 9px;
      margin-top: -30px !important;
    }

    .lr-report-buttons {
      float: none;
      padding-top: 20px;
      clear: both;
      text-align: center;
    }

    .lr-report-title {
      float: none;
      text-align: center;
    }

    .lr-faq-keywords {
      height: auto;
    }

    .lr-seo-audit-photo {
      text-align: left;
    }

    .lr-seo-audit-photo img {
      width: 100%;
      max-height: none !important;
    }

    .lr-overall-box-left {
      float: none;
      width: 100%;
    }

    .lr-overall-box-right {
      clear: both;
      float: none;
      text-align: center;
      width: 100%;
    }

    .lr-recommendations-nr {
      margin: auto;
    }

    .lr-doughnut-wrapper {
      position: relative;
      margin: auto;
      width: 197px;
    }

    .lr-seo-box-left {
      float: none;
      width: 100%;
    }

    .lr-seo-box-right {
      clear: both;
      float: none;
      width: 100%;
    }

    .lr-backlinks-stats .lr-backlinks-stat {
      float: none;
      width:100%;
      padding-right: 0px;
    }

    .lr-backlinks-stats .lr-backlinks-stat.even {
      width: 100%;
      margin-bottom: 20px;
    }
  }
</style>